var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArtAndDesign(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M11.23 17.77a.34.34 0 0 0-.47.16c-.25.5.88.92-1.4 3.24a5.87 5.87 0 0 1-7.76.49 2.39 2.39 0 0 0 1.86-.81c2-1.87 1.2-5.51 4.36-5.35 1.48.08 1.41.75 1.91 1.21.74.68 1-.29.53-.38S10 15 7.88 14.74c-3.83-.42-3.49 3.69-5.21 5.26-.76.7-1.31.51-1.87.79s-.81 1 0 1.73a6.89 6.89 0 0 0 10.3-2.23c.39-.69.84-2.18.13-2.52Z",
    fill: "#00b1cc",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.69.21c-2.23.65-3.75 2.37-5 4.37-2.26 3.85-2.18 3.52-3.81 6.23-2.31 3.89-1.71 2.53-2.03 3.09a.32.32 0 0 0 .18.52c.55.18 2.23-2.78 2.52-3.21.45-.7.94-1.39 1.42-2.08 2.35-3.6 3.21-5.11 4.55-6.34 1.93-1.76 5.17-2.54 5 0-.15 3.81-5.07 6.84-7.52 9.41-.54.56-1 1.21-1.53 1.82-1.25 1.47-2.32 1.83-2.14 2.31.28.73 1.34-.5 2-1 .86-.75 1.5-1.71 2.29-2.48 2.53-2.46 6.07-4.38 7.62-7.79S22.82-.69 19.69.21Z",
    fill: "#82e1f2",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.51 5a13.84 13.84 0 0 0 2.84-2.73.31.31 0 0 0-.26-.35 1.53 1.53 0 0 0-1.39.49 15.27 15.27 0 0 0-1.85 2.34.42.42 0 0 0 .66.25Z",
    fill: "#00b1cc",
    fillRule: "evenodd"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArtAndDesign);
export default __webpack_public_path__ + "static/media/art-and-design.fd77d568c04f2bf260abd0e2cff173c9.svg";
export { ForwardRef as ReactComponent };